import React, { useState } from 'react';
import { useMessagesData } from '../context/MessagesContext';
import { FiMail, FiUser, FiCalendar, FiTrash2, FiEye, FiCheckCircle } from 'react-icons/fi';
import './Admin.css';

export default function AdminMessages() {
    const { messages, deleteMessage, markAsRead, loading } = useMessagesData();
    const [selectedMessage, setSelectedMessage] = useState(null);

    const handleViewMessage = (msg) => {
        setSelectedMessage(msg);
        if (!msg.read) {
            markAsRead(msg.id);
        }
    };

    const handleDelete = (e, id) => {
        e.stopPropagation();
        if (window.confirm('Supprimer ce message ?')) {
            deleteMessage(id);
            if (selectedMessage?.id === id) setSelectedMessage(null);
        }
    };

    // Helper to find the latest version of the selected message in the list
    const currentMessage = messages.find(m => m.id === selectedMessage?.id);

    return (
        <div className="admin-messages-page">
            <div className="admin-card">
                <div className="admin-card-header">
                    <div className="admin-card-title">
                        <FiMail />
                        <h2>Messages de contact ({messages.length})</h2>
                    </div>
                </div>

                <div className="admin-messages-layout">
                    {/* Sidebar: List of messages */}
                    <div className="messages-sidebar">
                        {loading ? (
                            <div className="admin-loader-inline">Chargement...</div>
                        ) : messages.length === 0 ? (
                            <div className="no-messages">Aucun message reçu.</div>
                        ) : (
                            <div className="messages-list">
                                {messages.map(msg => (
                                    <div
                                        key={msg.id}
                                        className={`message-item ${selectedMessage?.id === msg.id ? 'active' : ''} ${!msg.read ? 'unread' : ''}`}
                                        onClick={() => handleViewMessage(msg)}
                                    >
                                        <div className="message-item-header">
                                            <span className="msg-sender">{msg.name}</span>
                                            <span className="msg-date">{new Date(msg.created).toLocaleDateString()}</span>
                                        </div>
                                        <div className="message-item-preview">
                                            {msg.message.substring(0, 40)}...
                                        </div>
                                        {!msg.read && <span className="unread-dot"></span>}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* Content: Selected message details */}
                    <div className="message-view-content">
                        {currentMessage ? (
                            <div className="message-detail-view">
                                <div className="message-detail-header">
                                    <div className="detail-sender-info">
                                        <div className="detail-avatar">
                                            {currentMessage.name.charAt(0).toUpperCase()}
                                        </div>
                                        <div>
                                            <h3>{currentMessage.name}</h3>
                                            <p className="detail-email">{currentMessage.email}</p>
                                        </div>
                                    </div>
                                    <div className="detail-actions">
                                        <span className="detail-date">
                                            <FiCalendar /> {new Date(currentMessage.created).toLocaleString()}
                                        </span>
                                        <button
                                            className="admin-btn admin-btn-danger"
                                            onClick={(e) => handleDelete(e, currentMessage.id)}
                                        >
                                            <FiTrash2 /> Supprimer
                                        </button>
                                    </div>
                                </div>

                                <div className="message-body">
                                    <h4>Message :</h4>
                                    <div className="message-text-content">
                                        {currentMessage.message}
                                    </div>
                                </div>

                                <div className="message-footer-info">
                                    <FiCheckCircle /> Donnée synchronisée en temps réel avec PocketBase.
                                </div>
                            </div>
                        ) : (
                            <div className="message-placeholder">
                                <FiMail />
                                <p>Sélectionnez un message pour le lire</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
